export class DashboardSidebarHtml {
    sidebarskin () {
        return `
            <nav>
                <div class="navbar-header">
                    <div class="navbar-brand">
                    <img src="/assets/vetra.png" alt="Vetra">
                    </div>
                    <div class="menu-control d-flex align-center justify-space-between">
                    <span class="menu-label">MENU</span>
                    <button id="sidebarToggle"><span class="iconify" data-icon="ci:hamburger-md"></span></button>
                    </div>
                    <div class="navbar-menu">
                        <ul class="main-menu">
                            <li id="goDashboard" data-path="/dashboard/">
                            <span class="iconify" data-icon="material-symbols:overview-key-outline"></span>
                            <span class="menu-label">Overview</span>
                            </li>
                            <li id="goPV" data-path="/dashboard/pv">
                            <span class="iconify" data-icon="hugeicons:solar-panel-05"></span>
                            <span class="menu-label">PV</span>
                            </li>
                            <li id="goBESS" data-path="/dashboard/bess">
                            <span class="iconify" data-icon="solar:battery-low-broken"></span>
                            <span class="menu-label">BESS</span>
                            </li>
                            <li id="goStorage" data-path="/dashboard/generator">
                            <span class="iconify" data-icon="mdi:generator-mobile"></span>
                            <span class="menu-label">Generator</span>
                            </li>
                            <li id="goSchematics" data-path="/dashboard/schematics">
                            <span class="iconify" data-icon="mdi:space-station"></span>
                            <span class="menu-label">Schematics</span>
                            </li>
                            <li id="goMetStation" data-path="/dashboard/met-station">
                            <span class="iconify" data-icon="mdi:generator-stationary"></span>
                            <span class="menu-label">Met Stations</span>
                            </li>
                            <li id="goGrid" data-path="/dashboard/grid">
                            <span class="iconify" data-icon="f7:rectangle-3-offgrid-fill"></span>
                            <span class="menu-label">Grid Controllers</span>
                            </li>
                            <!-- <li id="goGrid" data-path="/dashboard/carbon-credit">
                            <span class="iconify" data-icon="mdi:leaf"></span>
                            <span class="menu-label">Carbon Credits</span>
                            </li> -->
                            <li id="goCommunication" data-path="/dashboard/communication">
                            <span class="iconify" data-icon="fluent:communication-20-filled"></span>
                            <span class="menu-label">Communication</span>
                            </li>
                            <li id="goDataTable" data-path="/dashboard/data-table">
                            <span class="iconify" data-icon="icon-park-outline:data-one"></span>
                            <span class="menu-label">Data Table</span>
                            </li>
                            <li id="goAlarms" data-path="/dashboard/alarms">
                            <span class="iconify" data-icon="mingcute:alert-line"></span>
                            <span class="menu-label">Alarms</span>
                            </li>
                            <li id="goDocuments" data-path="/dashboard/documents">
                            <span class="iconify" data-icon="solar:document-bold"></span>
                            <span class="menu-label">Documents</span>
                            </li>
                            <li id="goEventViewer" data-path="/dashboard/event-viewer">
                            <span class="iconify" data-icon="basil:user-solid"></span>
                            <span class="menu-label">Event Viewer</span>
                            </li>
                            <li id="goUserManagement" data-path="/dashboard/user-management">
                            <span class="iconify" data-icon="material-symbols:settings-rounded"></span>
                            <span class="menu-label">User Management</span>
                            </li>
                            <li id="goReports" data-path="/dashboard/reports">
                            <span class="iconify" data-icon="tabler:report-analytics"></span>
                            <span class="menu-label">Reports</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="user-actions">
                    <ul>
                                        <li id="realtimeToggle" role="button" tabindex="0" aria-pressed="false" title="Toggle MQTT realtime">
                                                <span id="mqttRealtimeIconWrap" class="mqtt-realtime-icon" aria-hidden="true">
                                                    <span class="iconify" data-icon="mdi:wifi"></span>
                                                </span>
                                                <span class="menu-label">Realtime</span>
                                        </li>
                    <li id="themeToggle">
                        <span class="iconify" data-icon="line-md:switch"></span>
                        <span>Theme</span>
                    </li>
                    <li id="logout">
                        <span class="iconify" data-icon="hugeicons:logout-01"></span>
                        <span>Logout</span>
                    </li>
                    </ul>
                </div>
            </nav>
        `;
    }
}